import { render, staticRenderFns } from "./PortalPersonalTab.vue?vue&type=template&id=6bcb2ad2&"
import script from "./PortalPersonalTab.vue?vue&type=script&lang=js&"
export * from "./PortalPersonalTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports